<template lang="pug">
.charts
    .quadchart(ref="quadchart", v-show="!isOptionEmpty")
    .emptychart(v-show="isOptionEmpty")
    .loadingchart(v-show="loading")
</template>

<script>
//import { quadChartOptionFactory } from "./option.js"
import Vue from 'vue';
import resizeMixin from "./resize.mixin.js"

export default {
    mixins : [resizeMixin],
    props : {
        height : {
            type : [Number, String],
            default : 300
        },
        listSeries : Array,
        avgSeries : Object,
        loading : {
            type : Boolean,
            default : true
        },
        axisNames : Object
    },
    data(){
        return {
            chart : null,
            avgValue1 : 0,
            avgValue2 : 0,
            clickable : true,//echarts鬼点击，每次点击需要锁一下
            selfDataSeries : [],
            ordinarySeries : []
        }
    },
    computed : {
        isOptionEmpty : function(){
            return _.isEmpty(this.listSeries);
        },
        setQuadSeries(){
            let quadSeries = [];
            if (_.isEmpty(this.ordinarySeries)) {//first draw
                let series = this.getSeriesData(this.listSeries,this.avgSeries).seriesData;
                this.selfDataSeries = series[1];
                this.ordinarySeries = series[0];
            }
            quadSeries = [
                {
                    data: this.ordinarySeries,
                    name: '同行业账户',
                    type: 'scatter',
                    symbolSize: 9,
                    itemStyle : {
                        normal : {
                            borderColor: '#a3d39c',
                            borderWidth: 1,
                            opacity: 0.5
                        }
                    }
                },
                {
                    data: this.selfDataSeries,
                    name: '您的账户',
                    type: 'scatter',
                    symbolSize: 10,
                    itemStyle : {
                        normal : {
                            color : 'rgb(244,96,84)',
                            borderColor: 'rgba(244,96,84,0.5)',
                            borderWidth: 4,
                            opacity : 1
                        }
                    }
                }
            ];
            return quadSeries; 
        },
        getAxisRange(){
            let axisRange = [];
            axisRange = this.getSeriesData(this.listSeries,this.avgSeries).axisRange;
            return axisRange;
        }

    },
    methods : {
        initChart() { 
            let dom = this.$refs.quadchart;
            if(dom){
                this.chart = echarts.init(dom, null, {height: this.height});
            }
        },
        getSeriesData(list, avg){
            let selfSeries = [], otherSeries = [],
                seriesData = [],
                axisRange = {},
                xRange = 0, yRange = 0,
                xAvg = 0, yAvg = 0;
            list.map((item, index) => {
                let tempArr = [];

                xAvg = item.value1 - avg.avgValue1;
                yAvg = item.value2 - avg.avgValue2;

                //get bottom xAxis & yAsix range
                xRange = xRange < Math.abs(xAvg) ? Math.abs(xAvg) : xRange;
                yRange = yRange < Math.abs(yAvg) ? Math.abs(yAvg) : yRange;
                
                tempArr.push(xAvg);
                tempArr.push(yAvg);

                if (item.self && item.self === 1) { 
                    selfSeries.push(tempArr);
                    this.quadContend = this.getQuadPosition(tempArr);
                } else {
                    otherSeries.push(tempArr);
                }
            });
            seriesData.push(otherSeries);
            seriesData.push(selfSeries);
            
            axisRange.xRange = xRange;
            axisRange.yRange = yRange;

            return { seriesData, axisRange }
        },
        getQuadPosition(arr) {
            if (arr.length === 0) 
                return;
            
            if (arr[0] > 0) {
                if (arr[1] > 0) {//右上角，第一象限
                    this.$emit("quadPosition",1); 
                } else if (arr[1] < 0) {//右下角，第四象限
                    this.$emit("quadPosition",4); 
                }
            } 
            if (arr[0] < 0) {
                if (arr[1] < 0) {//左下角，第三象限
                    this.$emit("quadPosition",3); 
                } else if (arr[1] > 0) {//左上角，第二象限
                    this.$emit("quadPosition",2); 
                }
            }
        },
        draw() {
            if(!this.chart && !this.isOptionEmpty) {
                this.initChart();
            }
            if(this.chart){
                let _self = this;
                let _textStyle = {
                    color: '#999',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontFamily: 'sans-serif',
                    fontSize: 12,
                };
                let _xAxisValue = {
                    name: this.axisNames.xName,
                    nameLocation: 'end',
                    nameGap: 15,
                    splitNumber: 1,
                    splitLine : { 
                      show : true,
                      lineStyle: {
                          type : 'solid',
                          color : '#ededed'
                      }
                    },
                    axisLine:{
                        show: true,
                        lineStyle: {
                            color: '#aaa',
                            width: 1,
                            type: 'dashed'
                        }  
                    },
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    max: _self.getAxisRange.xRange*1.1,
                    min: -_self.getAxisRange.xRange*1.1,
                };
                let _yAxisValue = {
                    name: this.axisNames.yName,
                    nameLocation: 'end',
                    nameGap: 15,
                    splitNumber: 1,
                    splitLine : { 
                      show : true,
                      lineStyle: {
                          type : 'solid',
                          color : '#ededed'
                      }
                    },
                    axisLine:{
                        show: true,
                        lineStyle: {
                            color: '#aaa',
                            width: 1,
                            type : 'dashed'
                        }  
                    },
                    
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    max: _self.getAxisRange.yRange*1.1,
                    min: -_self.getAxisRange.yRange*1.1
                };

                let option = {
                    grid : {
                        left: 100,
                        right: 100
                    },
                    tooltip: { show : false },
                    color: ['#a3d39c','#f46054'],
                    legend: {
                        data: ['同行业账户','您的账户'],
                        align: 'left',
                        right: 15,
                        bottom: 15,
                        itemWidth: 12,
                        itemHeight: 12,
                        itemGap: 15,
                        textStyle: _textStyle
                    },
                    xAxis: _xAxisValue,
                    yAxis: _yAxisValue,
                    series : _self.setQuadSeries
                };
                this.chart.setOption(option, {
                    notMerge: true 
                });
                this.chart.on('click',function(params){
                    if (params.seriesIndex === 0 && _self.clickable){ 
                        let removeIndex = params.dataIndex;
                        _self.ordinarySeries.splice(removeIndex, 1);
                        _self.listSeries.splice(removeIndex, 1);
                        _self.clickable = false;
                    }
                });
            }
        }
    },
    watch: {
        ordinarySeries() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.draw(), 100);
            this.clickable = true;
        }
    },
    updated(){
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.draw(), 100);
    },
    destroyed() {
        this.chart = null;
        clearTimeout(this.timer);
    }
}



</script>



// WEBPACK FOOTER //
// quadrantsChart.vue?25a999a3